import React from "react";
import { REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { getRedeemUrlWithContext } from "../../utils";

function EuropcarTactical2Main() {
  const redeemUrl = getRedeemUrlWithContext("europcar-tactical-2");

  return (
    <>
      <OnboardingPage
        redeemUrl={redeemUrl}
        rewardId={REWARD_OFFERING.europcartactical2}
      />
    </>
  );
}

export default EuropcarTactical2Main;
